import React from 'react';
import { Activity } from 'lucide-react';

interface SolarFlareBadgeProps {
  label?: string;
  className?: string;
}

export const SolarFlareBadge: React.FC<SolarFlareBadgeProps> = ({ 
  label = "All-Time High", 
  className = "" 
}) => {
  return (
    <div className={`flex items-center gap-1.5 group cursor-default ${className}`}>
      {/* The Orb Container 
        - Size: 24px (w-6 h-6)
        - Gradient: Yellow to Orange
        - Shadow: Glowing effect that intensifies on hover
      */}
      <div className="relative flex items-center justify-center w-[17px] h-[17px] rounded-full bg-gradient-to-br from-yellow-400 to-orange-600 shadow-[0_0_10px_rgba(234,179,8,0.5)] group-hover:shadow-[0_0_15px_rgba(234,179,8,0.7)] transition-shadow duration-300">
        
        {/* The Pulse Animation */}
        <div className="absolute inset-0 rounded-full bg-yellow-400 animate-ping opacity-20"></div>
        
        {/* The Icon 
          - Bleeds to edge (w-full h-full)
          - Minimal padding (p-0.5) ensures it touches the boundaries
          - Black stroke provides max contrast
        */}
        <Activity className="w-[14px] h-[14px] p-0.5 text-black drop-shadow-sm stroke-[2]" />
      </div>

      {/* The Text Label */}
      <span className="text-[11px] font-bold text-yellow-500 uppercase tracking-wide group-hover:text-yellow-400 transition-colors">
        {label}
      </span>
    </div>
  );
};

export default SolarFlareBadge;
